import { type Dispatch, type SetStateAction, useMemo } from 'react';

import { useUserConfig } from '@/features/_shared/user';
import type { Conversation } from '@/features/ai-chat/types/chat.types';

export function useChatHistory(setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>) {
  const { data: userConfig } = useUserConfig();

  const conversations = useMemo<Conversation[]>(() => {
    const history = (userConfig?.chatHistory ?? []) as Conversation[];
    return [...history].toSorted((a, b) => {
      if (a.timestamp === b.timestamp) return 0;
      return new Date(a.timestamp) > new Date(b.timestamp) ? -1 : 1;
    });
  }, [userConfig?.chatHistory]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return { conversations, handleClose } as const;
}
